import { getRespondentProofOfHuman } from "../../api/Project";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../themes/components/Loader";
import { notify } from "../../themes/components/Notifications";
import MainLayout from "../../themes/layouts/Main";
import { isEmpty } from "lodash";
import Box from "@mui/material/Box";
import FormStickyHeader from "../../components/FormStickyHeader";

const ProofOfHumanSession: React.FC = () => {
  const { id } = useParams(),
    [data, setData] = useState<ProjectResponse | null>(null),
    [loading, setLoading] = useState<boolean>(true),
    [error, setError] = useState<boolean>(false);

  const getData = async () => {
    if (!id) return;
    const response: ProjectResponseProofOfHuman = await getRespondentProofOfHuman(id);
    const { result, messages } = response.projectResponseProofOfHuman;
    if (!isEmpty(messages)) {
      notify(messages, "error");
      setError(true);
    } else if (result) {
      setData(result);
    }
    setLoading(false);
  };

  const getProofOfHumanSession = () => {
    if (!data?.rt_proof_of_human) return null;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return JSON.parse(data?.rt_proof_of_human) || null;
  };

  const getKey = (key: string): string => {
    return key
      .replace(/([A-Z])/g, " $1") // Insert a space before each uppercase letter
      .replace(/(\d+)/g, " $1 ") // Add spaces around numbers
      .replace(/^./, (str) => str.toUpperCase()) // Capitalize the first letter
      .trim();
  };

  const getValue = (value: any): string => {
    if (null === value) return "-";
    if (typeof value === "object") return JSON.stringify(value, null, 2);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return value.toString();
  };

  useEffect(() => {
    if (!data) {
      void getData();
    }
  });

  if (loading) {
    return <Loader />;
  }

  const proofOfHumanSessionData = getProofOfHumanSession();

  return (
    <MainLayout>
      <FormStickyHeader>
        <p style={{ margin: 0 }}>Proof of human session for respondent</p>
        <p style={{ fontSize: "medium", margin: 0 }}>Respondent Id: {data?.id}</p>
      </FormStickyHeader>
      <Box sx={{ px: 4, py: 2.8, mt: 12 }}>
        {!proofOfHumanSessionData && (
          <p>There isn't any Proof of human session data for this respondent.</p>
        )}
        {error && <p>An unexpected error has occurred.</p>}
        {proofOfHumanSessionData && (
          <ul>
            {Object.entries(proofOfHumanSessionData).map(([key, value]) => (
              <li key={key}>
                {value && typeof value === "object" && Object.keys(value).length ? (
                  <ul style={{ paddingLeft: "2rem" }}>
                    {Object.entries(value).map(([childKey, childValue]) => (
                      <li key={childKey}>
                        <strong>{getKey(childKey)}</strong>: {getValue(childValue)}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span>
                    <strong>{getKey(key)}</strong>: {getValue(value)}
                  </span>
                )}
              </li>
            ))}
          </ul>
        )}
      </Box>
    </MainLayout>
  );
};

export default ProofOfHumanSession;
